// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2JzvM","alert":"SettungsInbox_alert__2f33m"};